/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import {
  activateDeactivate,
  getDeactivatedVideoListing,
} from "../../../../app/modules/Auth/_redux/authCrud";
import DeleteBlock from "../../../../app/modules/Modals/DeleteBlock";
import ViewUserModal from "../../../../app/modules/UserProfile/components/ViewUserModal";
import {
  NoData,
  // PageChanger,
  // PagedDiv,
} from "../../../../GobalStyled";

export function AdvanceTablesWidget15({ className }) {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [userData, setUserData] = useState([]);
  // console.log(userData, "userData--------------");
  // eslint-disable-next-line no-unused-vars
  const [page, setPage] = useState(1);
  const [openDelete, setOpenDelete] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [parameter, setParameter] = useState({});
  const [data, setData] = useState([]);
  const history = useHistory();
  const baseUrl = "https://d17am3tdlggecz.cloudfront.net/";
  const enableLoading = () => {
    setLoading(true);
  };
  const VideoPreview = ({ src }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    if (error) {
      return (
        <div
          style={{
            width: "150px",
            height: "90px",
            background: "#ffe6e6",
            color: "#d32f2f",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            fontSize: "12px",
          }}
        >
          Video not available
        </div>
      );
    }

    return (
      <>
        {loading && (
          <div
            style={{
              width: "150px",
              height: "90px",
              background: "#f2f2f2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
              fontSize: "12px",
            }}
          >
            Loading...
          </div>
        )}

        <video
          src={src}
          autoPlay
          muted
          playsInline
          style={{
            width: "150px",
            borderRadius: "8px",
            display: loading ? "none" : "block",
          }}
          onLoadedData={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      </>
    );
  };
  const disableLoading = () => {
    setLoading(false);
  };

  // eslint-disable-next-line no-unused-vars


  const getUserListing = () => {
    enableLoading();
    getDeactivatedVideoListing()
      .then(({ data }) => {
        setUserData(data);
        // console.log(data);
        disableLoading();
        // dispatch(loginAdmin(data))
      })
      .catch(() => {
        disableLoading();
      });
  };
  const handleActive = (id, media) => {
    setOpenDelete(true);
    let para = {
      name: "Activate",
      body: "this video",
      id: id,
      media: media,
    };
    // console.log(para);
    setParameter(para);
  };
  const getSearchWord = async (word) => {
    const s = word.target.value.trim();

    if (s.length > 0) {
      try {
        const { data } = await getDeactivatedVideoListing(s);
        setUserData(data);
      } catch {
        disableLoading();
      }
    } else {
      getUserListing();
    }
  };
  const ActiveDeactive = async () => {
    setModalLoading(true);
    // const req = {
    //   id: parameter.id,
    //   media: parameter.media,
    // };
    const id = parameter.id;
    const media = parameter.media;
    // console.log(id, media, "req--------------");
    let res = await activateDeactivate(id, media);
    if (res.status === 200) {
      setModalLoading(false);
      setOpenDelete(false);
      toast.info(res.message);
      getUserListing();
    } else {
      setModalLoading(false);
      setOpenDelete(false);
      toast.info(res.message);
    }
  };

  useEffect(() => {
    getUserListing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  if (loading) {
    return (
      <div className="LoaderWrapper">
        <div className="BackgroundLoader" />
      </div>
    );
  }

  return (
    <>
      <div
        className={`card card-custom ${className}`}
        style={{ minHeight: "65vh" }}
      >
        {openDelete && (
          <DeleteBlock
            open={openDelete}
            close={() => setOpenDelete(false)}
            confirmSumbit={ActiveDeactive}
            parameter={parameter}
            loading={modalLoading}
          />
        )}

        <div className="card-header border-0 pt-0">
          <h3 className="card-title align-items-start flex-column">

            <span className="text-muted mt-3 font-weight-bold font-size-sm"></span>
          </h3>

          <input
            name="search"
            type="search"
            placeholder="Search"
            onChange={getSearchWord}
            className="form-control w-25  ml-auto mt-5"
          />
        </div>
        {userData?.length > 0 ? (
          userData.map((ele) => (
            <div className="card-body pt-3 pb-0" key={ele._id}>
              <div className="table-responsive">
                <table className="table table-borderless table-vertical-center">
                  <thead>
                    <tr>
                      <th className="p-0" style={{ width: "60px" }} />
                      <th className="p-0" style={{ minWidth: "250px" }} />
                      <th className="p-0" style={{ minWidth: "100px" }} />

                      <th className="p-0" style={{ minWidth: "150px" }} />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="pl-0 py-8">
                        <div className="d-flex align-items-center">
                          {/* <video
                          key={item}
                          src={baseurl + item}
                          autoPlay
                          muted
                          // controls
                          style={{
                            width: "150px",
                            borderRadius: "8px",
                            marginBottom: "10px",
                          }}
                        /> */}
                          <VideoPreview src={baseUrl + ele?.mediaUrls[0]} />
                        </div>
                      </td>
                      <td className="pl-0">
                        <span

                          className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg cursor-pointer"
                        >
                          {ele.firstName + " " + ele.lastName}
                        </span>
                        <div>
                          <span className="font-weight-bolder">Email: </span>
                          <a
                            className="text-muted font-weight-bold text-hover-primary"
                            href="#"
                          >
                            {ele?.email}
                          </a>
                        </div>
                      </td>

                      <td className="text-right"></td>

                      <td className="text-right pr-0">
                        <button
                          className="btn btn-light-success btn-sm font-weight-bolder font-size-sm mx-1"
                          onClick={() => {
                            history.push("/user-details", { id: ele?.postProfileId });
                            setData(ele?.postProfileId);
                          }}
                        >
                          View
                        </button>
                        <button
                          className="btn btn-light-danger btn-sm font-weight-bolder font-size-sm mx-1"
                          onClick={() => handleActive(ele?._id, ele?.mediaUrls)}
                        >
                          Activate
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))
        ) : (
          <NoData>DATA NOT FOUND</NoData>
        )}

        {show && (
          <ViewUserModal open={show} data={data} close={() => setShow(false)} />
        )}
      </div>
    </>
  );
}
